import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import CheckBox from "../../../../../../../components/checkbox/CheckBox";
import Input from "../../../../../../../components/textbox/Input";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Utils from "../../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json";

class CollettivitaFrequentata extends Component {

    state = {
        collettivitaFrequentata: {
            scuola: "",
            tipoCollettivitaScuola: "",
            nomeCollettivitaScuola: "",
            comuneScuola: "",

            ospedale: "",
            tipoCollettivitaOspedale: "",
            nomeCollettivitaOspedale: "",
            comuneOspedale: "",

            strutturaRecettiva: "",
            tipoCollettivitaStrutturaRecettiva: "",
            nomeCollettivitaStrutturaRecettiva: "",
            comuneStrutturaRecettiva: "",

            altro: "",
            evntualeAltro: "",
            tipoCollettivitaAltro: "",
            nomeCollettivitaAltro: "",
            comuneAltro: "",

            campoNomadi: "",
            nomeCollettivitaCampoNomadi: "",
            comuneCampoNomadi: "",

            corretto: []

        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.collettivitaFrequentata) {
            let collettivitaFrequentata = this.state.collettivitaFrequentata
            let collettivitaFrequentataCopia = this.props.segnalazioneCopia.schedaSpeciale.collettivitaFrequentata
            for (let key in collettivitaFrequentata) {
                if (collettivitaFrequentataCopia.hasOwnProperty(key) === collettivitaFrequentata.hasOwnProperty(key)) {
                    collettivitaFrequentata[key] = collettivitaFrequentataCopia[key]
                } else {
                    collettivitaFrequentata[key] = ""
                }
            }
            this.setState({collettivitaFrequentata: collettivitaFrequentata})
            let oggettoBE = this.createObjectBE()
            let corretto = this.controlloCorrettezza()
            this.props.createOggettoBeAndcontrolloCorrettezza("collettivitaFrequentata", oggettoBE, corretto, this.validate())
        } else {
            let oggettoBE = this.createObjectBE()
            let corretto = this.controlloCorrettezza()
            this.props.createOggettoBeAndcontrolloCorrettezza("collettivitaFrequentata", oggettoBE, corretto, this.validate())
        }
    }

    riceviValore(field, event) {
        let collettivitaFrequentata = this.state.collettivitaFrequentata
        collettivitaFrequentata[field] = event.target.value
        if (collettivitaFrequentata.altro === "false") {
            collettivitaFrequentata.evntualeAltro = ""
            collettivitaFrequentata.tipoCollettivitaAltro = ""
        }
        if (collettivitaFrequentata.scuola === "false") {
            collettivitaFrequentata.tipoCollettivitaScuola = ""
        }
        if (collettivitaFrequentata.ospedale === "false") {
            collettivitaFrequentata.tipoCollettivitaOspedale = ""
        }
        if (collettivitaFrequentata.strutturaRecettiva === "false") {
            collettivitaFrequentata.tipoCollettivitaStrutturaRecettiva = ""
        }


        this.setState({collettivitaFrequentata: collettivitaFrequentata})
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloCorrettezza()
        this.props.createOggettoBeAndcontrolloCorrettezza("collettivitaFrequentata", oggettoBE, corretto, this.validate())
    }

    validate() {

        if (this.state.collettivitaFrequentata.scuola !== "true" && this.state.collettivitaFrequentata.tipoCollettivitaScuola) {
            return "Messages.ERR_01_02_0G_AN"
        }
        if (this.state.collettivitaFrequentata.scuola !== "true" && this.state.collettivitaFrequentata.nomeCollettivitaScuola) {
            return "Messages.ERR_01_02_0G_AR"
        }
        if (this.state.collettivitaFrequentata.scuola !== "true" && this.state.collettivitaFrequentata.comuneScuola) {
            return "Messages.ERR_01_02_0G_AZ"
        }
        if (this.state.collettivitaFrequentata.ospedale !== "true" && this.state.collettivitaFrequentata.tipoCollettivitaOspedale) {
            return "Messages.ERR_01_02_0G_AO"
        }
        if (this.state.collettivitaFrequentata.ospedale !== "true" && this.state.collettivitaFrequentata.nomeCollettivitaOspedale) {
            return "Messages.ERR_01_02_0G_AS"
        }
        if (this.state.collettivitaFrequentata.ospedale !== "true" && this.state.collettivitaFrequentata.comuneOspedale) {
            return "Messages.ERR_01_02_0G_BA"
        }
        if (this.state.collettivitaFrequentata.strutturaRecettiva !== "true" && this.state.collettivitaFrequentata.tipoCollettivitaStrutturaRecettiva) {
            return "Messages.ERR_01_02_0G_AP"
        }
        if (this.state.collettivitaFrequentata.strutturaRecettiva !== "true" && this.state.collettivitaFrequentata.nomeCollettivitaStrutturaRecettiva) {
            return "Messages.ERR_01_02_0G_AT"
        }
        if (this.state.collettivitaFrequentata.strutturaRecettiva !== "true" && this.state.collettivitaFrequentata.comuneStrutturaRecettiva) {
            return "Messages.ERR_01_02_0G_BB"
        }
        if (this.state.collettivitaFrequentata.altro !== "true" && this.state.collettivitaFrequentata.tipoCollettivitaAltro) {
            return "Messages.ERR_01_02_0G_AQ"
        }
        if (this.state.collettivitaFrequentata.altro !== "true" && this.state.collettivitaFrequentata.nomeCollettivitaAltro) {
            return "Messages.ERR_01_02_0G_AU"
        }
        if (this.state.collettivitaFrequentata.altro !== "true" && this.state.collettivitaFrequentata.comuneAltro) {
            return "Messages.ERR_01_02_0G_BC"
        }
        if (this.state.collettivitaFrequentata.campoNomadi !== "true" && this.state.collettivitaFrequentata.nomeCollettivitaCampoNomadi) {
            return "Messages.ERR_01_02_0G_AV"
        }
        if (this.state.collettivitaFrequentata.campoNomadi !== "true" && this.state.collettivitaFrequentata.comuneCampoNomadi) {
            return "Messages.ERR_01_02_0G_BD"
        }

        return ""

    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.collettivitaFrequentata))
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    controlloCorrettezza() {
        let collettivitaFrequentata = this.state.collettivitaFrequentata
        collettivitaFrequentata.corretto = []

        if ((collettivitaFrequentata.altro === "true" && !collettivitaFrequentata.evntualeAltro) ||
            (collettivitaFrequentata.scuola === "true" && (!collettivitaFrequentata.tipoCollettivitaScuola || !collettivitaFrequentata.nomeCollettivitaScuola || !collettivitaFrequentata.comuneScuola)) ||
            (collettivitaFrequentata.ospedale === "true" && (!collettivitaFrequentata.tipoCollettivitaOspedale || !collettivitaFrequentata.nomeCollettivitaOspedale || !collettivitaFrequentata.comuneOspedale)) ||
            (collettivitaFrequentata.strutturaRecettiva === "true" && (!collettivitaFrequentata.tipoCollettivitaStrutturaRecettiva || !collettivitaFrequentata.nomeCollettivitaStrutturaRecettiva || !collettivitaFrequentata.comuneStrutturaRecettiva)) ||
            (collettivitaFrequentata.altro === "true" && (!collettivitaFrequentata.tipoCollettivitaAltro || !collettivitaFrequentata.nomeCollettivitaAltro || !collettivitaFrequentata.comuneAltro)) ||
            (collettivitaFrequentata.campoNomadi === "true" && (!collettivitaFrequentata.nomeCollettivitaCampoNomadi || !collettivitaFrequentata.comuneCampoNomadi))) {
            collettivitaFrequentata.corretto[0] = "Campo \"Collettività frequentata\" mancante";
        }

    }

    render() {
        const {t} = this.props

        const collettivitaFrequentata = (
            <div style={{backgroundColor: "#e3e4e687"}}>
                <div style={{marginLeft: "1rem"}}>
                    <div className={"row"}>
                        <div className={"col-lg-8"}>
                            <h6 style={{paddingTop: "0.5rem"}}>{t("SchedaSpecialeMorbillo.collettivitaFrequentata")}</h6>
                        </div>
                        <div className={"col-lg-2"} style={{paddingTop: "0.5rem"}}>
                            <p style={{color: "black", fontWeight: "bold"}}>
                                {t("SchedaSpecialeMorbillo.nomeCollettivita")}
                            </p>
                        </div>
                        <div className={"col-lg-2"} style={{paddingTop: "0.5rem"}}>
                            <p style={{color: "black", fontWeight: "bold"}}>
                                {t("SchedaSpecialeMorbillo.comune")}
                            </p>
                        </div>
                    </div>

                    <div className={"row"}>
                        <div className={"col-lg-3"}>
                            <CheckBox id={"scuola"}
                                      isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                      text={t("SchedaSpecialeMorbillo.scuola")}
                                      newCheckbox={true}
                                      checked={this.state.collettivitaFrequentata.scuola === "true" ? true : false}
                                      onChange={this.riceviValore}
                                      required={this.state.collettivitaFrequentata.scuola === "true"}
                            >
                            </CheckBox>
                        </div>
                        <div className={"col-lg-5"}>
                            <div className={"row"}>
                                <div className={"col-lg-7"}>
                                    <RadioButton id={"tipoCollettivitaScuola1"}
                                                 name={"tipoCollettivitaScuola"}
                                                 label={t("SchedaSpecialeMorbillo.personaleScolastico")}
                                                 value={"1"}
                                                 newRadio={true}
                                                 disabled={this.state.collettivitaFrequentata.scuola !== "true"}
                                                 onClick={this.riceviValore}
                                                 checked={(this.state.collettivitaFrequentata.tipoCollettivitaScuola == "1")}
                                    ></RadioButton>
                                </div>
                                <div className={"col-lg-4"}>
                                    <RadioButton id={"tipoCollettivitaScuola2"}
                                                 name={"tipoCollettivitaScuola"}
                                                 label={t("SchedaSpecialeMorbillo.studente")}
                                                 value={"2"}
                                                 newRadio={true}
                                                 disabled={this.state.collettivitaFrequentata.scuola !== "true"}
                                                 onClick={this.riceviValore}
                                                 checked={(this.state.collettivitaFrequentata.tipoCollettivitaScuola == "2")}
                                    ></RadioButton>
                                </div>
                            </div>
                        </div>
                        <div className={"col-lg-4"}>
                            <div className={"row"}>
                                <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input id={"nomeCollettivitaScuola"}
                                           onChange={this.riceviValore}
                                           field={"nomeCollettivitaScuola"}
                                           value={this.state.collettivitaFrequentata.nomeCollettivitaScuola}
                                           placeholder={t("SchedaSpecialeMorbillo.nomeCollettivita")}
                                           required={this.state.collettivitaFrequentata.scuola === "true"}
                                    ></Input>
                                </div>
                                <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Input id={"comuneScuola"}
                                           onChange={this.riceviValore}
                                           field={"comuneScuola"}
                                           value={this.state.collettivitaFrequentata.comuneScuola}
                                           placeholder={t("SchedaSpecialeMorbillo.comune")}
                                           required={this.state.collettivitaFrequentata.scuola === "true"}
                                    ></Input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-lg-3"}>
                            <CheckBox id={"ospedale"}
                                      isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                      checked={this.state.collettivitaFrequentata.ospedale === "true" ? true : false}
                                      text={t("SchedaSpecialeMorbillo.ospedale")}
                                      newCheckbox={true}
                                      onChange={this.riceviValore}
                                      defaultChecked={this.state.collettivitaFrequentata.ospedale === "true" ? true : false}
                                      required={this.state.collettivitaFrequentata.ospedale === "true"}
                            >
                            </CheckBox>
                        </div>
                        <div className={"col-lg-5"}>
                            <div className={"row"}>
                                <div className={"col-lg-7"}>
                                    <RadioButton id={"tipoCollettivitaOspedale1"}
                                                 name={"tipoCollettivitaOspedale"}
                                                 label={t("SchedaSpecialeMorbillo.personaleSanitario")}
                                                 value={"1"}
                                                 newRadio={true}
                                                 disabled={this.state.collettivitaFrequentata.ospedale !== "true"}
                                                 onClick={this.riceviValore}
                                                 checked={(this.state.collettivitaFrequentata.tipoCollettivitaOspedale == "1")}
                                    ></RadioButton>
                                </div>
                                <div className={"col-lg-4"}>
                                    <RadioButton id={"tipoCollettivitaOspedale2"}
                                                 name={"tipoCollettivitaOspedale"}
                                                 label={t("SchedaSpecialeMorbillo.ricoverato")}
                                                 value={"2"}
                                                 newRadio={true}
                                                 disabled={this.state.collettivitaFrequentata.ospedale !== "true"}
                                                 onClick={this.riceviValore}
                                                 checked={(this.state.collettivitaFrequentata.tipoCollettivitaOspedale == "2")}
                                    ></RadioButton>
                                </div>
                            </div>
                        </div>
                        <div className={"col-lg-4"}>
                            <div className={"row"}>
                                <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input id={"nomeCollettivitaOspedale"}
                                           onChange={this.riceviValore}
                                           field={"nomeCollettivitaOspedale"}
                                           value={this.state.collettivitaFrequentata.nomeCollettivitaOspedale}
                                           placeholder={t("SchedaSpecialeMorbillo.nomeCollettivita")}
                                           required={this.state.collettivitaFrequentata.ospedale === "true"}

                                    ></Input>
                                </div>
                                <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Input id={"comuneOspedale"}
                                           onChange={this.riceviValore}
                                           field={"comuneOspedale"}
                                           value={this.state.collettivitaFrequentata.comuneOspedale}
                                           placeholder={t("SchedaSpecialeMorbillo.comune")}
                                           required={this.state.collettivitaFrequentata.ospedale === "true"}

                                    ></Input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-lg-3"}>
                            <CheckBox id={"strutturaRecettiva"}
                                      isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                      checked={this.state.collettivitaFrequentata.strutturaRecettiva === "true" ? true : false}
                                      text={t("SchedaSpecialeMorbillo.strutturaRecettiva")}
                                      newCheckbox={true}
                                      onChange={this.riceviValore}
                                      defaultChecked={this.state.collettivitaFrequentata.strutturaRecettiva === "true" ? true : false}
                                      required={this.state.collettivitaFrequentata.strutturaRecettiva === "true"}

                            >
                            </CheckBox>
                        </div>
                        <div className={"col-lg-5"}>
                            <div className={"row"}>
                                <div className={"col-lg-7"}>
                                    <RadioButton id={"tipoCollettivitaStrutturaRecettiva1"}
                                                 name={"tipoCollettivitaStrutturaRecettiva"}
                                                 label={t("SchedaSpecialeMorbillo.personaleStruttura")}
                                                 value={"1"}
                                                 newRadio={true}
                                                 disabled={this.state.collettivitaFrequentata.strutturaRecettiva !== "true"}
                                                 onClick={this.riceviValore}
                                                 checked={(this.state.collettivitaFrequentata.tipoCollettivitaStrutturaRecettiva == "1")}
                                    ></RadioButton>
                                </div>
                                <div className={"col-lg-4"}>
                                    <RadioButton id={"tipoCollettivitaStrutturaRecettiva2"}
                                                 name={"tipoCollettivitaStrutturaRecettiva"}
                                                 label={t("SchedaSpecialeMorbillo.ospite")}
                                                 value={"2"}
                                                 newRadio={true}
                                                 disabled={this.state.collettivitaFrequentata.strutturaRecettiva !== "true"}
                                                 onClick={this.riceviValore}
                                                 checked={(this.state.collettivitaFrequentata.tipoCollettivitaStrutturaRecettiva == "2")}
                                    ></RadioButton>
                                </div>
                            </div>
                        </div>
                        <div className={"col-lg-4"}>
                            <div className={"row"}>
                                <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input id={"nomeCollettivitaStrutturaRecettiva"}
                                           onChange={this.riceviValore}
                                           field={"nomeCollettivitaStrutturaRecettiva"}
                                           value={this.state.collettivitaFrequentata.nomeCollettivitaStrutturaRecettiva}
                                           placeholder={t("SchedaSpecialeMorbillo.nomeCollettivita")}
                                           required={this.state.collettivitaFrequentata.strutturaRecettiva === "true"}

                                    ></Input>
                                </div>
                                <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Input id={"comuneStrutturaRecettiva"}
                                           onChange={this.riceviValore}
                                           field={"comuneStrutturaRecettiva"}
                                           value={this.state.collettivitaFrequentata.comuneStrutturaRecettiva}
                                           placeholder={t("SchedaSpecialeMorbillo.comune")}
                                           required={this.state.collettivitaFrequentata.strutturaRecettiva === "true"}

                                    ></Input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-lg-1"}>
                            <CheckBox id={"altro"}
                                      isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                      checked={this.state.collettivitaFrequentata.altro === "true" ? true : false}
                                      text={t("SchedaSpecialeMorbillo.altro")}
                                      newCheckbox={true}
                                      onChange={this.riceviValore}
                                      defaultChecked={this.state.collettivitaFrequentata.altro === "true" ? true : false}
                                      required={this.state.collettivitaFrequentata.altro === "true"}

                            >
                            </CheckBox>
                        </div>
                        <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <Input id={"evntualeAltro"}
                                   onChange={this.riceviValore}
                                   field={"evntualeAltro"}
                                   required={this.state.collettivitaFrequentata.altro === "true"}
                                   disabled={this.state.collettivitaFrequentata.altro !== "true"}
                                   value={this.state.collettivitaFrequentata.evntualeAltro}
                                   placeholder={t("SchedaSpecialeMorbillo.altro")}
                            ></Input>
                        </div>
                        <div className={"col-lg-5"}>
                            <div className={"row"}>
                                <div className={"col-lg-7"}>
                                    <RadioButton id={"tipoCollettivitaAltro1"}
                                                 name={"tipoCollettivitaAltro"}
                                                 label={t("SchedaSpecialeMorbillo.personaleStruttura")}
                                                 value={"1"}
                                                 newRadio={true}
                                                 disabled={this.state.collettivitaFrequentata.altro !== "true"}
                                                 onClick={this.riceviValore}
                                                 checked={(this.state.collettivitaFrequentata.tipoCollettivitaAltro == "1")}
                                    ></RadioButton>
                                </div>
                                <div className={"col-lg-4"}>
                                    <RadioButton id={"tipoCollettivitaAltro2"}
                                                 name={"tipoCollettivitaAltro"}
                                                 label={t("SchedaSpecialeMorbillo.ospite")}
                                                 value={"2"}
                                                 newRadio={true}
                                                 disabled={this.state.collettivitaFrequentata.altro !== "true"}
                                                 onClick={this.riceviValore}
                                                 checked={(this.state.collettivitaFrequentata.tipoCollettivitaAltro == "2")}
                                    ></RadioButton>
                                </div>
                            </div>
                        </div>
                        <div className={"col-lg-4"}>
                            <div className={"row"}>
                                <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input id={"nomeCollettivitaAltro"}
                                           onChange={this.riceviValore}
                                           field={"nomeCollettivitaAltro"}
                                           value={this.state.collettivitaFrequentata.nomeCollettivitaAltro}
                                           placeholder={t("SchedaSpecialeMorbillo.nomeCollettivita")}
                                           required={this.state.collettivitaFrequentata.altro === "true"}

                                    ></Input>
                                </div>
                                <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Input id={"comuneAltro"}
                                           onChange={this.riceviValore}
                                           field={"comuneAltro"}
                                           value={this.state.collettivitaFrequentata.comuneAltro}
                                           placeholder={t("SchedaSpecialeMorbillo.comune")}
                                           required={this.state.collettivitaFrequentata.altro === "true"}
                                    ></Input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-lg-3"}>
                            <CheckBox id={"campoNomadi"}
                                      isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                      checked={this.state.collettivitaFrequentata.campoNomadi === "true" ? true : false}
                                      text={t("SchedaSpecialeMorbillo.campoNomadi")}
                                      newCheckbox={true}
                                      onChange={this.riceviValore}
                                      defaultChecked={this.state.collettivitaFrequentata.campoNomadi === "true" ? true : false}
                            >
                            </CheckBox>
                        </div>
                        <div className={"col-lg-5"}></div>
                        <div className={"col-lg-4"}>
                            <div className={"row"}>
                                <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input id={"nomeCollettivitaCampoNomadi"}
                                           onChange={this.riceviValore}
                                           field={"nomeCollettivitaCampoNomadi"}
                                           value={this.state.collettivitaFrequentata.nomeCollettivitaCampoNomadi}
                                           placeholder={t("SchedaSpecialeMorbillo.nomeCollettivita")}
                                           required={this.state.collettivitaFrequentata.campoNomadi === "true"}
                                    ></Input>
                                </div>
                                <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Input id={"comuneCampoNomadi"}
                                           onChange={this.riceviValore}
                                           field={"comuneCampoNomadi"}
                                           value={this.state.collettivitaFrequentata.comuneCampoNomadi}
                                           placeholder={t("SchedaSpecialeMorbillo.comune")}
                                           required={this.state.collettivitaFrequentata.campoNomadi === "true"}
                                    ></Input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )

        return (
            <div className={"container"}>
                {collettivitaFrequentata}
            </div>
        );
    }

}

export default withTranslation('common')(CollettivitaFrequentata)
